<template>
  <div class="k-collapse-folder">
    <v-list-item @click="$emit('click-header')" :value="collapsevalue" :active="active">
      <template v-slot:prepend v-if="iconPosition === 'left'">
        <v-btn variant="text" icon size="small" density="comfortable" class="d-flex align-center" @click="toggle">
          <span v-if="isOpen" class="my-auto d-flex">
            <ui-icon name="chevron-down" :size="20"></ui-icon>
          </span>
          <span v-else class="my-auto d-flex">
            <ui-icon name="chevron-right" :size="20"></ui-icon>
          </span>
        </v-btn>
      </template>

      <v-list-item-title class="handle-widgets hover">
        <p :class="titleClass" class="mr-2">{{ title }}</p>
      </v-list-item-title>

      <template v-slot:append>
        <template v-if="$slots.actions">
          <slot name="actions"></slot>
        </template>
        <v-btn v-if="iconPosition === 'right'" variant="text" icon size="small" density="comfortable"
          class="d-flex align-center" @click="toggle">
          <span v-if="isOpen" class="my-auto d-flex">
            <ui-icon name="chevron-down" :size="20"></ui-icon>
          </span>
          <span v-else class="my-auto d-flex">
            <ui-icon name="chevron-right" :size="20"></ui-icon>
          </span>
        </v-btn>
      </template>
    </v-list-item>

    <v-expand-transition>
      <div class="px-0" v-show="isOpen">
        <slot></slot>
      </div>
    </v-expand-transition>
    <template v-if="$slots.footer">
      <slot name="footer"></slot>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: this.open, // Lokale kopie van de prop
    };
  },
  props: {
    titleClass: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      required: true,
    },
    open: {
      type: Boolean,
      default: false,
    },
    iconPosition: {
      type: String,
      default: "left",
    },
    active: { type: Boolean, default: false },
    collapsevalue: {
      type: [String, Number, Object, Boolean],
      default: "",
    },
  },
  watch: {
    // Zorgt ervoor dat als de `open` prop verandert, de lokale `isOpen` wordt geüpdatet
    open(newVal) {
      this.isOpen = newVal;
    },
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>
<style>
.k-collapse-folder {
  .v-list-item__prepend {
    width: 28px;
  }

  .v-list-item-title.handle-widgets {
    display: flex !important;
    align-items: center !important;
    line-height: 1.4rem !important;
  }
}
</style>
